// extracted by mini-css-extract-plugin
export default {"table":"Doc_table__QdGrV","form_control_label":"Doc_form_control_label__iRcyQ"};